import classes from "./ApiKeyModal.module.css";
import ModalWrapper from "../../modalWrapper/ModalWrapper";
import { ActionBtn } from "../../buttons/actionBtn/ActionBtn";
import { useTranslations } from "../../../helperFunctions/customHooks/useTranslations";
import { useRef, useState } from "react";
import { setIsApiKeyModalShown } from "../../../redux/globalFunctions/globalFnSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetGenerateApiKeyState } from "../../../redux/integrations/generateApiKey";

export function ApiKeyModal() {
  const apiKeyRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const modalText = t.apiKeyModal;

  const { apiKey } = useSelector((state) => state.generateApiKey);

  const [successCopied, setSuccessCopied] = useState(false);

  function handleCloseModal() {
    dispatch(setIsApiKeyModalShown(false));
    dispatch(resetGenerateApiKeyState());
    setSuccessCopied(false);
  }

  const handleCopy = (e) => {
    e.preventDefault();
    if (apiKeyRef.current) {
      const text = apiKeyRef.current.textContent;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setSuccessCopied(true);
          setTimeout(() => {
            setSuccessCopied(false);
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy API key:", err);
        });
    }
  };

  return (
    <ModalWrapper
      title={modalText.title}
      onClick={handleCloseModal}
      style={{ width: "600px" }}
    >
      <form className={classes.form}>
        <p ref={apiKeyRef}>{apiKey}</p>
        {successCopied && <span>{modalText.successCopy}</span>}
        <ActionBtn
          width={"100%"}
          height={"42px"}
          onClick={handleCopy}
          text={"Copy"}
        />
      </form>
    </ModalWrapper>
  );
}
